module.exports = __webpack_public_path__ + "static/media/third-block-img2.3a51b76f.svg";